module.exports = __webpack_public_path__ + "img/logo-brand.17662e9c.png";